import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for Permission Roles.
 *
 * Endpoints:
 * - `getPermissionRoleList` – GET `/user/roles` → list of permission roles
 *
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const permissionRoleApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getPermissionRoleList: builder.query({
            query: () => ({
                url: '/user/roles',
                method: 'GET',
            }),
            providesTags: [CC_API_TAGS.PermissionRole],
        }),
    }),
});
export const { useGetPermissionRoleListQuery } = permissionRoleApi;
